import React from 'react'
import style from './OilRecordEcoUser.module.css'
import oilStyle from '../Oil.module.css'
import { OilRecordIcon } from '../../../assets/icons'
import { Translate } from '../../../language'
import TitleSVG from '../../../utils/components/TitleSVG/TitleSVG'
import OilRecordItem from './OilRecordItemEcoUser'
import OilRecordList from './OilRecordListEcoUser'

const OilRecord = ({ historicalDelivery, totalPointsDelivery, totalLitersDelivery, skipHistoricalDelivery, setSkipHistoricalDelivery, limitHistoricalDelivery }) => {
    const scrollPagination = (e) => {
        if (e.target.scrollTop + 1 >= e.target.scrollHeight - e.target.clientHeight) {
            setSkipHistoricalDelivery(skipHistoricalDelivery + limitHistoricalDelivery);
        }
    }

    return (

        <div className={style.container}>

            <TitleSVG Icon={OilRecordIcon}
                titleHighlight={Translate('oilRecordTitleHighlight', 'es')}
                title={Translate('oilRecordTitle', 'es')} />

            <div className={style.record_container}>
                <div className={style.subtitle_container}>
                    <div className={style.subtitle}>
                        <span className={oilStyle.subtitle_text}>{Translate('totalLitersReceived', 'es')}</span>
                        <span className={oilStyle.subtitle_text_highlight}>{totalLitersDelivery} {Translate('liters', 'es')} </span>
                    </div>

                    <div className={style.subtitle}>
                        <span className={oilStyle.subtitle_text}>{Translate('totalOfReceivedPoints', 'es')} </span>
                        <span className={oilStyle.subtitle_text_highlight}> {totalPointsDelivery} {Translate('ecoPoints', 'es')} </span>
                    </div>

                </div>

                <div className={style.record_grid_container}>
                    <div className={style.record_grid} onScroll={scrollPagination}>
                        <div className={style.record_grid_title}>{Translate('date', 'es')}</div>
                        <div className={style.record_grid_title}>{Translate('quantity', 'es')}</div>
                        <div className={style.record_grid_title}>{Translate('ecoPoints', 'es')}</div>

                        <OilRecordList>
                            {historicalDelivery.map(delivery => (
                                <OilRecordItem
                                    key={delivery.id}
                                    date={delivery.date}
                                    quantity={delivery.quantity}
                                    ecopoints={delivery.ecopoints}
                                />
                            ))}
                        </OilRecordList>

                    </div>
                </div>
            </div>
        </div>


    )
}

export default OilRecord